import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import EstablishmentRegistration from '@/components/EstablishmentRegistration'
import regist from '@/components/regist'
// import companyLargeScreen from '@/components/companyLargeScreen'
// import database from '@/components/database'
import home from '@/components/home'
import PClogin from '@/components/PClogin'
// import submenu from '@/components/submenu'
// import XYBS from '@/components/XYBS'
// import PIM from '@/components/PIM'
// import menuBar from '@/components/menuBar'
Vue.use(Router)

import {
  UserPage
} from '../js/API.js'
import axios from 'axios'
const Routers = [
  {
    path: '/',
    name: 'ScmLogin',
    component: () => import('@/components/ScmLogin'),
  },
  {
    path: '/EstablishmentRegistration',
    name: 'EstablishmentRegistration',
    component: EstablishmentRegistration
  },
  {
    path: '/companyLargeScreen',
    name: 'companyLargeScreen',
    component: () => import('@/components/companyLargeScreen'),
  },
  {
    path: '/regist',
    name: 'regist',
    component: regist
  },
  {
    path: '/home',
    name: 'home',
    component: home,
    children: [ {
      path: '/panel',
      name: 'panel',
      component: () => import('@/flow/ef/panel')
    }]
  },
  {
    path: '/PClogin',
    name: 'PClogin',
    component: PClogin
  },
  {
    path: '/PCmerchandise',
    name: 'PCmerchandise',
    component: () => import('@/components/PCmerchandise'),
  },
]
// = new Router({
//   // mode: 'history',
//   routes:})

// this.$router.addRoutes(newRoutes);
// this.$router.options.routes = this.$router.options.routes.concat(newRoutes);
const contextInfo = require.context('@/views', true, /.vue$/);
let routerAry = []
contextInfo.keys().forEach(fileName => {
  const pathConfig = contextInfo(fileName)
  let path = "/" + fileName.substring(2, fileName.length - 4)
  let name = "/" + fileName.substring(2, fileName.length - 4)
  routerAry.push({
    path,
    name,
    component: pathConfig.default
  })
})
// const contextInfos = require.context('@/flow/ef', true, /.vue$/);
// let routerArys = []
// contextInfos.keys().forEach(fileNames => {
//     console.log(fileNames)
//   const pathConfigs = contextInfo(fileNames)
//   let path = "/" + fileNames.substring(2, fileNames.length - 4)
//   routerArys.push({
//     path,
//     component: pathConfigs.default
//   })
// }),
// ,...routerArys
// if(Routers[4].children && routerAry){
//   Routers[4].children = [...Routers[4].children, ...routerAry]
// }
Routers[4].children = [...Routers[4].children, ...routerAry]

const newRouterAry = Routers
let router = new Router({
  mode: 'history',
  routes: newRouterAry
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js